import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { RealEstateAdvisory } from "./pages/RealEstateAdvisory";
import { HospitalityResortsAdvisory } from "./pages/HospitalityResortsAdvisory";
import { LandAssetTransactions } from "./pages/LandAssetTransactions";
import { CommercialLeasing } from "./pages/CommercialLeasing";
import { InvestmentFinanceAdvisory } from "./pages/InvestmentFinanceAdvisory";
import { InternationalTrade } from "./pages/InternationalTrade";
import { ActiveMandates } from "./pages/ActiveMandates";
import { StrategicOpportunities } from "./pages/StrategicOpportunities";
import { GlobalNetwork } from "./pages/GlobalNetwork";
import { InvestorNetwork } from "./pages/InvestorNetwork";
import { AdminContactSubmissions } from "./pages/AdminContactSubmissions";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/real-estate" element={<RealEstateAdvisory />} />
          <Route path="/services/hospitality-resorts" element={<HospitalityResortsAdvisory />} />
          <Route path="/services/land-asset-transactions" element={<LandAssetTransactions />} />
          <Route path="/services/commercial-leasing" element={<CommercialLeasing />} />
          <Route path="/services/investment-finance" element={<InvestmentFinanceAdvisory />} />
          <Route path="/services/international-trade" element={<InternationalTrade />} />
          <Route path="/active-mandates" element={<ActiveMandates />} />
          <Route path="/strategic-opportunities" element={<StrategicOpportunities />} />
          <Route path="/global-network" element={<GlobalNetwork />} />
          <Route path="/investor-network" element={<InvestorNetwork />} />
          <Route path="/admin/contacts" element={<AdminContactSubmissions />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
